import React from 'react';
import SPPAnswerTipsRow from './SPPAnswerTipsRow';

const SPPAnswerTips = ({ item = {}, assignment }) => {
  const { part, tips } = item;
  const { students } = assignment;
  const title = 'Answer';
  return (
    <SPPAnswerTipsRow
      key={part.responseId}
      title={title}
      assignment={assignment}
      item={part}
      students={students}
    >
      {tips.map((item, index) => {
        const tipTitle = `Tip ${index + 1}`;
        return (
          <SPPAnswerTipsRow
            key={item.responseId}
            title={tipTitle}
            assignment={assignment}
            item={item}
            students={students}
          />
        );
      })}
    </SPPAnswerTipsRow>
  );
};

export default SPPAnswerTips;
